import { SET_LANGUAGE } from '../Constants/actionTypes';

export const setLanguage = (payload) => (dispatch) => {
  dispatch({
    type: SET_LANGUAGE,
    payload,
  });
};
